import React, { useState, useEffect } from 'react';

import { useHistory } from 'react-router';

import { Button } from 'antd';

import { getTourId } from 'app/components/Utility/utility';

import { SeeListIcon, SeeMapIcon } from 'app/components/Desctop/MainMenu/svg';

const Switch = (props) => {
  const [switchValue, setSwitchValue] = useState('map');

  const history = useHistory();

  const url = props.router.location.pathname.split('/').slice(0, -1).join('/');

  const getSwitchValue = () => {
    if (props.router.location.pathname.split('/').slice(-1)[0] === 'list') {
      setSwitchValue('list');
    } else {
      setSwitchValue('map');
    }
  };

  useEffect(() => {
    getSwitchValue();
  }, []);

  useEffect(() => {
    getSwitchValue();
  }, [props.router.location.pathname]);

  const getElem = () => {
    if (
      !getTourId(props.router) ||
      props.router.location.pathname?.match('/folders')
    ) {
      if (switchValue === 'map') {
        return (
          <Button
            style={{ padding: 5 }}
            onClick={() => {
              setSwitchValue('list');
              history.push(`${props.router.location.pathname}/list`);
            }}
          >
            <SeeListIcon />
          </Button>
        );
      }
      return (
        <Button
          style={{ padding: 5 }}
          onClick={() => {
            setSwitchValue('map');
            history.push(url);
          }}
        >
          <SeeMapIcon />
        </Button>
      );
    }
    return null;
  };
  return (
    <div className="switchListMap" style={{ marginRight: '15px' }}>
      {getElem()}
    </div>
  );
};

export default Switch;
